import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

function resolveSiteUrl(route: ActivatedRouteSnapshot): string | null {
    let current: ActivatedRouteSnapshot | null = route;
    while (current) {
        const url = current.params['url'];
        if (url) {
            return url;
        }
        current = current.parent;
    }
    return null;
}

export const canManageUsersGuard: CanActivateFn = async (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    await auth.ready;

    if (!auth.isAuthenticated()) {
        return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }

    const profile = await firstValueFrom(
        auth.profile$.pipe(filter((p) => p !== null), take(1)),
    );

    if (profile?.role === 'PLATFORM_ADMIN' || profile?.role === 'SITE_ADMIN') {
        return true;
    }

    const siteUrl = resolveSiteUrl(route);
    if (siteUrl) {
        return router.createUrlTree(['/sites', siteUrl, 'manage', 'pages']);
    }
    return router.createUrlTree(['/sites']);
};
